import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { openInsertEmbedPromptAndReturnNode } from 'proseShared/prompts/EmbedPrompt/EmbedPrompt'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertEmbedButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const openPrompt = async () => {
    dropdownStore?.hardClose()
    const embedNode = await openInsertEmbedPromptAndReturnNode({ view, centered: true })

    if (embedNode) {
      insertAndFocus(view, embedNode)
    }
  }

  return (
    <SingleMenuDropdownItem icon={<ToolbarIcon name={IconName.BrowserCode} />} label="Embed" handleClick={openPrompt} />
  )
}
